import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import './AutoRenewal.css';

const AutoRenewal = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [autoRenewal, setAutoRenewal] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }
    const fetchSetting = async () => {
      try {
        const { data } = await axios.get('/api/subscription/auto-renewal');
        setAutoRenewal(data.autoRenewal);
      } catch {
        setError('Не удалось загрузить настройку. Попробуйте позже.');
      } finally {
        setLoading(false);
      }
    };
    fetchSetting();
  }, [user, navigate]);

  const handleToggle = async () => {
    const newValue = !autoRenewal;
    setAutoRenewal(newValue);
    setSaving(true);
    setSaved(false);
    setError('');
    try {
      const { data } = await axios.patch('/api/subscription/auto-renewal', {
        autoRenewal: newValue
      });
      setAutoRenewal(data.autoRenewal);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch {
      setAutoRenewal(!newValue);
      setError('Не удалось сохранить настройку. Попробуйте снова.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ar-page">
      <div className="ar-card">
        <button className="ar-back" onClick={() => navigate(-1)}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Назад
        </button>

        <div className="ar-header">
          <div className="ar-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          </div>
          <h1 className="ar-title">Автопродление подписки</h1>
          <p className="ar-subtitle">
            Управляйте автоматическим списанием средств при истечении подписки
          </p>
        </div>

        {loading ? (
          <div className="ar-loader">
            <div className="ar-spinner" />
          </div>
        ) : (
          <>
            <div className="ar-toggle-row">
              <div className="ar-toggle-info">
                <span className="ar-toggle-label">Автоматическое продление</span>
                <span className="ar-toggle-desc">
                  {autoRenewal
                    ? 'Подписка продлится автоматически при истечении срока'
                    : 'Подписка не будет продлеваться автоматически'}
                </span>
              </div>
              <button
                className={`ar-toggle${autoRenewal ? ' ar-toggle--on' : ''}`}
                onClick={handleToggle}
                disabled={saving}
                aria-label="Переключить автопродление"
              >
                <span className="ar-toggle-knob" />
              </button>
            </div>

            {saved && (
              <div className="ar-notice ar-notice--success">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Настройка сохранена
              </div>
            )}

            {error && (
              <div className="ar-notice ar-notice--error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {error}
              </div>
            )}

            <div className="ar-info-block">
              <p>
                При отключении автопродления ваша подписка продолжит работу до конца оплаченного периода,
                после чего автоматического списания средств не последует.
              </p>
              <p>
                Вы можете повторно включить автопродление в любой момент.
              </p>
            </div>
          </>
        )}

        <div className="ar-footer-links">
          <a href="http://naix.cc/refund.html">Политика возврата</a>
          {' · '}
          <a href="https://naix.cc/privacy.html">Политика конфиденциальности</a>
          {' · '}
          <a href="https://naix.cc/oferta.html">Публичная оферта</a>
        </div>
      </div>
    </div>
  );
};

export default AutoRenewal;
